<template>
  <div class="main-container">
    <div class="messaging">
      <div class="conversations-list" @keydown.esc="deselectConversation" tabindex="0"
        v-if="!connectionError && !connecting">
        <div class="search">
          <input class="search" type="text" :placeholder="$t('common.search')" v-model="searchQuery" />
        </div>
        <div class="list">
          <div class="spring-spinner" v-if="loadingConversations">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
          <div v-for="conversation in sortedConversations" @click="selectConversation(conversation.sid)" :class="`conversation ${selectedConversation.sid == conversation.sid
            ? 'selected-conversation'
            : ''
            }`">
            <h2 class="name noselect">
              {{
                conversation.friendlyName
              }}
            </h2>
            <p class="date noselect">
              {{
                conversation.lastMessage
                  ? dateToTime(conversation.lastMessage.dateCreated)
                  : dateToTime(conversation.dateUpdated)
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="conversation-messages" v-if="selectedConversation.sid">
        <div class="header">
          <p>
            {{
              selectedConversation.friendlyName

            }}
          </p>
        </div>
        <div class="messages-container" ref="messagesContainer" @scroll="paginateMessages()">
          <div class="messages">
            <label class="loadingLabel" v-if="loadingMessages">{{ $t("communication.messages.loading") }}</label>
            <div class="message" v-for="(m, indexMMM) in arrangedConversations" :key="indexMMM"
              :sent="m[0].author === userIdentity ? 'true' : ''">
              <div class="historyStamp"
                v-if="indexMMM === 0 || getFormattedDate(new Date(m[0].dateCreated)) != getFormattedDate(new Date(arrangedConversations[indexMMM - 1][0].dateCreated))">
                <span class="historyStampSpan">{{ getFormattedDate(new Date(m[0].dateCreated)) }}</span>
              </div>
              <div :class="['bubble', { sys_bubble: body.author === 'System' }]" v-for="(body, index) in m"
                :notSeen="body.index > lastReadMessageIndex ? 'true' : ''"
                :CCUser="body.author.includes('MC_taxi_CC') ? 'true' : ''">
                <div class="author" :style="`color:${colorCoding(body.author)};`" v-if="
                  participantsCount > 2 && index == 0
                ">{{isAgent(body.author) ? getFirstName(body.author) : body.author }}
                </div>
                <div class="message-content" v-html="formatBody(body.body)">


                </div>
                <div class="message-info">
                  <span style="float: left">{{
                    moment(body.dateUpdated).format("HH[h]mm")
                  }}</span>
                  <!-- <span style="float: right" v-if="!selectedConversation.groupConversation && body.author == userIdentity"> -->
                  <span style="float: right" class="seenSpan">
                    <span>{{
                      body.index <= lastReadMessageIndex ? $t("communication.messages.seen") : $t("communication.messages.sent") }}</span>
                    </span>

                    <span style="float: right" class="seenSpanCC" v-if="body.author.includes('MC_taxi_CC')">
                      <span>{{
                        body.index <= lastReadMessageIndex ? $t("communication.messages.seen") : "" }}</span>
                      </span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="send-message">
          <textarea style="width: 100%;
            background-color: white;" type="text" rows="3" :disabled="sendingMessage" @keyup.enter="sendMessage"
            v-model="message" :placeholder="$t('communication.messages.sendMessage')" ref="sendTextarea" />
          <!--<button class="send-msg" @click="sendMessage">Send</button>-->

        </div>
      </div>
      <div class="conversation-messages" v-else>
        <div class="no-conversation-selected">
          <label class="noselect" v-if="connecting">
            {{ $t("communication.messages.connecting") }}
          </label>
          <label class="noselect" v-else-if="connectionError">
            {{ $t("communication.messages.connectionError") }}
          </label>
          <label class="noselect" v-else v-html="$t('communication.messages.selectConversation')">
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Messaging",
  data() {
    return {
      conversations: [],
      participantsCount:0,
      message: "",
      selectedConversation: {},
      selectedConversationMessagesEntity: null,
      loadingMessages: false,
      loadingConversations: false,
      selectedConversationMessages: [],
      client: null,
      storeClientWatcher: null,
      searchQuery: "",
      users: [],
      sendingMessage: false,
      lastReadMessageIndex: -1,
      groupConversation: false,
    };
  },
  computed: {
    connectionError() {
      return this.client &&
        !["connecting", "connected"].includes(this.client.connectionState)
        ? true
        : false;
    },
    connecting() {
      return this.client && this.client.connectionState == "connecting"
        ? true
        : false;
    },
    userIdentity() {
      return this.client.user.identity;
    },
    sortedConversations() {
      if (this.searchQuery == "")
        return this.conversations.sort(function (a, b) {
          let aDate = a.lastMessage ? new Date(a.lastMessage.dateCreated) : 1,
            bDate = b.lastMessage ? new Date(b.lastMessage.dateCreated) : 0;
          return bDate - aDate;
        });
      else return this.search(this.searchQuery);
    },
    arrangedConversations() {
      let conversations = [];
      if (this.selectedConversationMessages.length) {
        let arr = [];
        for (let i = 0; i < this.selectedConversationMessages.length; i++) {
          // if (this.selectedConversationMessages[i + 1]) {
          //   if (
          //     this.selectedConversationMessages[i].author ===
          //     this.selectedConversationMessages[i + 1].author
          //   ) {
          //     arr.push(this.selectedConversationMessages[i]);
          //   } else if (this.selectedConversationMessages[i]) {
          //     arr.push(this.selectedConversationMessages[i]);
          //     conversations.push(arr);
          //     arr = [];
          //   }
          // } else {
          //this.selectedConversationMessages[i].body=  this.selectedConversationMessages[i].body.replace("\n","<br/>")
          arr.push(this.selectedConversationMessages[i]);
          conversations.push(arr);
          arr = [];
          // }
        }
      }
      return conversations;
    },
  },
  methods: {
    formatBody(text) {
      return text.replace(/\n/g, '<br/>');
    },
    getFormattedDate(string) {
      const currentDate = new Date().toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
      const month = this.monthName(string.getMonth());
      const day = this.addLeadingZero(string.getDate());

      if (`${month} ${string.getDate()}` == currentDate) {
        return this.$t("communication.messages.today");
      } else if (this.isYesterday(string.getMonth(), day)) {
        return this.$t("communication.messages.yesterday");
      } else {
        return `${this.$t(`communication.messages.months.${string.getMonth()}`)} ${day}`;
      }
    },
    isYesterday(month, day) {
      const currentDate = new Date();
      const targetDate = new Date(currentDate.getFullYear(), month, day);

      // Calculate the date one day ago
      currentDate.setDate(currentDate.getDate() - 1);

      return currentDate.toDateString() === targetDate.toDateString();
    },
    monthName(number) {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      return monthNames[number];
    },
    addLeadingZero(value) {
      return value < 10 ? `0${value}` : value;
    },
    getBooleanUnreadMessagesCount() {
      this.$store.dispatch(
        "setUnreadMessageConversationPreference",
        ""
      );
      this.$store.dispatch(
        "setUnreadMessagePreference",
        0
      );
    },
    isAgent(identity) {
      let prefix = "MC_taxi_CC";
      if (typeof identity == "string")
        return identity.includes(prefix);
      return false;
    },
    getFirstName(identity) {     
       let user = this.users.find(u => u.identity == identity) ;
       return user ? user.first_name : identity;
    },
    dateToTime(date) {
      return moment(date).fromNow();
    },
    search(q) {
      if (q != "") {
        let arr = [];
        let lowerCaseQuery = q.toLowerCase();
        // console.log("dddd",this.conversations)
        //  console.log("ccc",this.sortedConversations)
        this.conversations.forEach((value) => {
          if (
            value.friendlyName
              .toLowerCase()
              .search(lowerCaseQuery) != -1
          )
            arr.push(value);
        });
        return arr;
      }
    },
    async sendMessage(event) {
      if (event.ctrlKey) {
        // Ctrl+Enter pressed: Insert a new line
        this.message += '\n';
        return;
      }
      if (this.message != "" && !this.sendingMessage) {
        this.sendingMessage = true;
        await this.selectedConversation
          .prepareMessage()
          .setAttributes({
            agentName: `${this.$store.state.user.first_name} ${this.$store.state.user.last_name}`,
            shownName: "Call Center",
          })
          .setBody(this.message)
          .build()
          .send();
        this.sendingMessage = false;
        this.message = "";
        setTimeout(() => {
          if (this.$refs.sendTextarea)
            this.$refs.sendTextarea.focus();
        }, 100);
        // refresh seen status from the other participants' read index
        const participants = await this.selectedConversation.getParticipants();
        this.updateReadIndexFromParticipants(participants);

      }

    },
    colorCoding(string) {
      const color = () => Math.floor(Math.random() * (160 - 80 + 1) + 40);
      return `rgb(${color()},${color()},${color()})`;
    },
    updateReadIndexFromParticipants(participants) {
      participants.forEach((participant) => {
        if (
          participant.identity &&
          !participant.identity.includes("MC_taxi_CC") &&
          !participant.identity.includes("MC_test_CC") &&
          typeof participant.lastReadMessageIndex === "number" &&
          participant.lastReadMessageIndex > this.lastReadMessageIndex
        ) {
          this.lastReadMessageIndex = participant.lastReadMessageIndex;
        }
      });
    },
    selectConversation(sid) {
      if (this.selectedConversation.sid != sid) {
        this.client
          .getConversationBySid(sid)
          .then(async (c) => {
            this.conversations.forEach((e) => {
              e.removeAllListeners("messageAdded");
              e.removeAllListeners("participantUpdated");
            });
            this.deselectConversation();
            this.selectedConversation = c;
            history.pushState(
              {},
              null,
              this.$route.path + `?conversation=${sid}`
            );

            // reset, then derive seen status from the other participants' read index
            this.lastReadMessageIndex = -1;
            this.selectedConversation.getParticipants()
              .then(participants => {
                this.participantsCount = participants.length;
                this.updateReadIndexFromParticipants(participants);
              })
              .catch(error => {
                console.error('Error fetching participants:', error);
              });

            this.selectedConversation.on("messageAdded", (data) => {
              if (data.conversation.sid === this.selectedConversation.sid) {
                this.selectedConversationMessages.push(data);
                this.selectedConversation.setAllMessagesRead();
                setTimeout(this.getBooleanUnreadMessagesCount(), 2000);
                window.requestAnimationFrame(() => {
                  this.$refs.messagesContainer.scrollTop =
                    this.$refs.messagesContainer.scrollHeight;
                });
              }
            });

            // keep seen status live as the captain reads messages
            this.selectedConversation.on("participantUpdated", (event) => {
              if (event.participant.conversation.sid == this.selectedConversation.sid) {
                this.updateReadIndexFromParticipants([event.participant]);
              }
            });
            this.loadingMessages = true;
            // this.lastReadMessageIndex = -1;
            c.getMessages().then(async (m) => {
              const participants = await c.getParticipants();
              let filteredParticipants = participants.filter(
                (item) => !item.identity.includes("MC_taxi_CC")
              );

              this.selectedConversationMessagesEntity = m;
              this.selectedConversationMessages = [
                ...this.selectedConversationMessages,
                ...m.items,
              ];
              window.requestAnimationFrame(() => {
                this.$refs.messagesContainer.scrollTop =
                  this.$refs.messagesContainer.scrollHeight;
              });
              await c.setAllMessagesRead();
              setTimeout(this.getBooleanUnreadMessagesCount(), 2000);
            });
          })
          .finally(() => {
            this.loadingMessages = false;
            setTimeout(() => {
              if (this.$refs.sendTextarea)
                this.$refs.sendTextarea.focus();
            }, 100);
          });
      }
    },
    paginateMessages() {
      if (!this.loadingMessages && this.selectedConversationMessagesEntity) {
        if (
          this.$refs.messagesContainer.scrollTop == 0 &&
          this.selectedConversationMessagesEntity.hasPrevPage
        ) {
          this.loadingMessages = true;
          let loadPrevMessagesScrollPos =
            this.$refs.messagesContainer.scrollHeight;
          this.selectedConversationMessagesEntity.prevPage().then((m) => {
            this.loadingMessages = false;
            this.selectedConversationMessagesEntity = m;
            this.selectedConversationMessages = [
              ...m.items,
              ...this.selectedConversationMessages,
            ];
            window.requestAnimationFrame(() => {
              this.$refs.messagesContainer.scrollTop =
                this.$refs.messagesContainer.scrollHeight -
                loadPrevMessagesScrollPos;
            });
          });
        }
      }
    },
    async retrieveAllConversations(retries = 3) {
      console.log("getting conversations")
      if (this.loadingConversations) return;
      this.loadingConversations = true;
      try {
        this.conversations = [];

        if (!this.client || this.client.connectionState !== 'connected') {
          throw new Error('Client not connected');
        }

        let paginator = await this.client.getSubscribedConversations();
        this.conversations.push(...paginator.items);
        while (paginator.hasNextPage) {
          await new Promise(r => setTimeout(r, 300));
          paginator = await paginator.nextPage();
          this.conversations.push(...paginator.items);
        }
        console.log("conversations done")
        if (this.$route.query.conversation)
          this.selectConversation(this.$route.query.conversation);
      } catch (err) {
        console.error('Error fetching conversations:', err);
        if (retries > 0) {
          const delay = (4 - retries) * 3000;
          console.log(`Retrying in ${delay / 1000}s... (${retries} retries left)`);
          this.loadingConversations = false;
          await new Promise(r => setTimeout(r, delay));
          return this.retrieveAllConversations(retries - 1);
        }
      } finally {
        this.loadingConversations = false;
      }
    },
    retrieveConversations() {
      this.loadingConversations = true;
      this.client
        .getSubscribedConversations()
        .then((data) => {
          data.nextPage().then((m) => {
            m.items.forEach((val, key) => {
              val.getUnreadMessagesCount().then((cnt) => {
                val.unreadMessagesCount = cnt;
              });
              this.conversations.push(val);
            });

            if (this.$route.query.conversation)
              this.selectConversation(this.$route.query.conversation);

            m.nextPage().then((n) => {
              n.items.forEach((val, key) => {
                val.getUnreadMessagesCount().then((cnt) => {
                  val.unreadMessagesCount = cnt;
                });
                this.conversations.push(val);
              });
              if (this.$route.query.conversation)
                this.selectConversation(this.$route.query.conversation);
              n.nextPage().then((h) => {
                h.items.forEach((val, key) => {
                  val.getUnreadMessagesCount().then((cnt) => {
                    val.unreadMessagesCount = cnt;
                  });
                  this.conversations.push(val);
                });
                if (this.$route.query.conversation)
                  this.selectConversation(this.$route.query.conversation);
                h.nextPage().then((p) => {
                  p.items.forEach((val, key) => {
                    val.getUnreadMessagesCount().then((cnt) => {
                      val.unreadMessagesCount = cnt;
                    });
                    this.conversations.push(val);
                  });
                  if (this.$route.query.conversation)
                    this.selectConversation(this.$route.query.conversation);

                });
              });
            });
          });
          data.items.forEach((val) => {
            val.groupConversation =
              Array.from(val.participants.values()).filter(
                ({ identity }) => !this.isAgent(identity)
              ).length > 1;
            this.conversations.push(val);
          });
          if (this.$route.query.conversation)
            this.selectConversation(this.$route.query.conversation);
        })
        .finally(() => {
          this.loadingConversations = false;
        });

      // this.client
      //   .getSubscribedConversations()
      //   .nextPage()
      //   .then((m) => {});
    },
    deselectConversation() {
      this.selectedConversation = {};
      this.selectedConversationMessages = [];
      this.selectedConversationMessagesEntity = null;
      this.selectedConversationMessagesCount = 0;
      history.pushState({}, null, this.$route.path);
    },
  },
  created() {
    this.client = this.$store.state.conversationClient;
    if (this.$store.state.user.roles[0].name == 'Goverment')
      this.$router.push(`/requests`)
    this.storeClientWatcher = this.$watch(
      () => this.$store.state.conversationClient
        ? this.$store.state.conversationClient.connectionState
        : null,
      (connectionState) => {
        this.client = this.$store.state.conversationClient;
        if (connectionState === "connected") {
          this.retrieveAllConversations();
        }
      },
      {
        immediate: true,
      }
    );
    this.axios.get(`user?allData=1`).then(({ data }) => {
      console.log("users", data)
      this.users = data.data
      console.log("users", this.users)
    });

  },
  beforeDestroy() {
    if (typeof this.storeClientWatcher === "function") {
      this.storeClientWatcher();
      this.storeClientWatcher = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
            supported by Chrome, Edge, Opera and Firefox */
}

.main-container {
  width: 100%;
  height: calc(100vh - 64px);
  padding: 28px;
  display: flex;
  justify-content: center;
  align-items: center;

  .messaging {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    max-width: 1400px;
    display: flex;
    flex-direction: row;
    box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.1);
    border-radius: 8px;
    overflow: hidden;

    .conversations-list {
      width: 30%;
      float: left;
      height: 100%;
      border-right: 1px solid #c2c6d9;
      min-width: 300px;
      max-width: 380px;
      flex-shrink: 0;
      flex-grow: 1;
      overflow-y: overlay;
      outline: none;

      &::-webkit-scrollbar {
        width: 0;
      }

      .search {
        width: 100%;
        padding: 16px;
        border-bottom: 1px solid #c2c6d9;
        float: left;
        position: sticky;
        top: 0;
        background: white;

        input {
          padding: 12px 16px;
          border-radius: 6px;
          background: #f7f8fa;
          width: 100%;
          border: 1px solid #c1c5d8;
          color: #222629;
          float: left;
          font-size: 14px;
          height: 40px;

          &::placeholder {
            color: #788e98;
          }

          &:focus {
            outline: none;
          }

          &::after {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .list {
        width: 100%;
        float: left;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px;

        .selected-conversation {
          box-shadow: inset 0px 0px 0px 1px #e10015 !important;
        }

        .conversation {
          width: 100%;
          box-sizing: border-box;
          padding: 12px 15px;
          border-radius: 8px;
          box-shadow: 0px 0px 6px rgba($color: #000b8a, $alpha: 0.06);
          float: left;
          background-color: white;
          cursor: pointer;
          transition: 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;
          max-width: 100%;
          gap: 12px;

          &:hover {
            box-shadow: 0px 0px 10px rgba($color: #000b8a, $alpha: 0.1);
          }

          .name {
            font-size: 14px;
            font-weight: 500;
            float: left;
            flex-grow: 0;
            flex-shrink: 1;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .last-message {
            font-size: 14px;
            color: #788e98;
            font-weight: 500;
            float: left;
            margin: 0;
            margin-top: 2px;
          }

          .date {
            float: right;
            margin: 0;
            color: #788e98;
            font-size: 14px;
            flex-grow: 0;
            flex-shrink: 0;
          }

          .messages-count {
            float: right;
            width: 18px;
            height: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #e10015;
            border-radius: 100%;
            margin-top: 5px;

            span {
              font-size: 10px;
              color: white;
              font-weight: 600;
              line-height: 0;
            }
          }
        }
      }
    }

    .conversation-messages {
      flex-grow: 1;
      flex-shrink: 1;
      height: 100%;
      float: left;
      display: flex;
      flex-direction: column;

      .header {
        width: 100%;
        padding: 16px 30px;
        float: left;
        font-size: 16px;
        font-weight: 600;
        background: #f0f2f4;
        flex-grow: 0;
        flex-shrink: 0;
        height: 72px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
          margin: 0;
        }
      }

      .messages-container {
        width: 100%;
        float: left;
        flex-grow: 1;
        flex-shrink: 1;
        padding: 12px 26px;
        overflow-y: overlay;
        position: relative;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 10px;
          background-color: #ededed;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          background-color: #788e98;
        }

        .messages {
          width: 100%;
          max-width: 100%;
          height: auto;
          display: flex;
          flex-direction: column;
          gap: 24px;
          float: left;
          position: relative;

          .loadingLabel {
            margin: auto;
          }

          .message {
            width: 100%;
            max-width: 100%;
            float: left;
            display: flex;
            height: auto;
            align-items: flex-start;
            gap: 5px;
            flex-direction: column;

            &[sent="true"] {
              align-items: flex-end;

              .bubble {
                // background: #fadadd;
                background: #c7e693;
                border: 1px solid #c7e693;

                &[notSeen="true"] {
                  background: #fadadd;
                  border: 1px solid #fadadd;
                }

                float: right;
                border-radius: 12px;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;

                &:first-child {
                  border-top-right-radius: 12px;
                }

                &:last-child {
                  border-bottom-right-radius: 12px;
                }

                .message-info {
                  width: 100%;
                  font-size: 10px;
                  float: left;
                  margin-top: 7px;

                  .seenSpan {
                    display: inline;
                  }

                  .seenSpanCC {
                    display: none;
                  }
                }
              }
            }

            .bubble {
              &[CCUser="true"] {
                background: #c7e693;
                border: 1px solid #c7e693;
              }

              padding: 11px;
              padding-top: 6px;
              padding-bottom: 4px;
              float: left;
              background: #dfe8ec;
              border: 1px solid #d6e0e5;
              border-radius: 12px;
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              max-width: 45%;

              .author {
                font-size: 12px;
                margin-bottom: 4px;
              }

              &:first-child {
                border-top-left-radius: 12px;
              }

              &:last-child {
                border-bottom-left-radius: 12px;
              }

              .message-content {
                width: 100%;
                font-size: 16px;
                float: left;
                color: #222629;
              }

              .message-info {
                width: 100%;
                font-size: 10px;
                float: left;
                margin-top: 7px;

                .seenSpan {
                  display: none;
                }

                .seenSpanCC {
                  display: inline;
                }
              }
            }

            .sys_bubble {
              background-color: rgb(240 187 192) !important;
            }
          }
        }
      }

      .send-message {
        float: left;
        flex-grow: 0;
        flex-shrink: 0;
        background: #f0f2f4;
        padding: 20px;

        input {
          padding: 12px 16px;
          border-radius: 6px;
          background: #f7f8fa;
          width: 100%;
          border: 1px solid #c1c5d8;
          color: #222629;
          float: left;
          font-size: 14px;

          &::placeholder {
            color: #788e98;
          }

          &:focus {
            outline: none;
          }

          &::after {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .no-conversation-selected {
        width: 100%;
        height: 100%;
        background: #f6f6f8;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        label {
          font-size: 18pt;
          margin-bottom: 24px;
          text-align: center;
        }
      }
    }
  }

  .historyStamp {
    width: 100%;
    text-align: center;

    .historyStampSpan {
      border: 2px solid white;
      padding: 7px;
      border-radius: 39%;
      background-color: lightgrey;
    }
  }

  .send-msg {
    width: 100%;
    background-color: #d2d2cc;
    padding: 10px;
    border-radius: 5px;
  }
}
</style>
